module.exports = __webpack_public_path__ + "static/media/Mixxtail.aa40c186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/Mixxtail.png
// module id = 459
// module chunks = 0